import React, { useContext, useEffect, useRef, useState } from 'react';
import eyeImg from '../assets/images/eye-1.svg';
import trashImg from '../assets/images/trash-2.svg';
import userImg from '../assets/images/user-8.svg';
import folderOpen from '../assets/images/folder-open-2.svg';
import { AccountContext } from '../context';
import { useDebounce } from '../helpers/useDebounce';
import {
  getImageUrl,
  getTenant,
  useGetGravatarOrUploadedProfileImg,
} from '../../../hooks';
import { getGravatarUrl } from 'react-awesome-gravatar';
import { AppDataContext, isJSON } from '../../../utils';
import { FiUser } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const DEFAULT_TENANT = 'main';

const Header = () => {
  const { t } = useTranslation('library');
  const { userMetaData, userData, handleImgUploadToAPI } =
    useContext(AccountContext);

  //const [isProfilePicSet, setIsProfilePicSet] = useState(false);
  //const [profilePic, setProfilePic] = useState('');
  const { appData, setAppData } = useContext(AppDataContext);

  const { isProfilePicSet, setIsProfilePicSet, setProfilePic, profilePic } =
    useGetGravatarOrUploadedProfileImg(appData.userMetaData);
  const [currentTenant, setCurrentTenant] = useState('');
  const [isTenantAdmin, setIsTenantAdmin] = useState(false);

  const uploadInputElement = useRef<HTMLInputElement>();

  const MAX_FILE_SIZE = 1024 * 1024;

  const handleImgPreviewClick = () => {
    window.open(profilePic, '_blank');
  };

  const handleImgUploadChange = async (e) => {
    if (!e) {
      return;
    }
    const file = e?.target?.files[0];
    if (file.size >= MAX_FILE_SIZE) {
      alert(t('Profile pic must not exceed 1Mb'));
      return;
    }
    const blobImg = URL.createObjectURL(file);
    setProfilePic(blobImg);
    setIsProfilePicSet(true);

    /*const formdata = new FormData();
    formdata.append("file", file)*/
    uploadInputElement.current.value = '';
    //const base64 = await convertToBinary(e);

    const formdata = new FormData();
    // Assuming `fileInput` is a reference to an <input type="file"> in your HTML
    formdata.append('file', file);
    handleImgUploadToAPI(formdata);

    /*const requestOptions = {
      method: "POST",
      //headers: myHeaders,
      body: formdata,
      redirect: "follow",
      credentials: 'include' // This line is added to include credentials like cookies
    };*/
  };

  const handleImgRemove = () => {
    setIsProfilePicSet(false);
  };

  const handleImgUploadClick = () => {
    if (!!isProfilePicSet) {
      return;
    }
    uploadInputElement.current.click();
  };

  const handleMainTenantJSRenameInTrialMode = () => {
    //CHECK IF TOPTRIALHEADER COMPONENT IS PRESENT THEN RENAME MAIN TO TRIAL
    if (document.getElementsByClassName('ibl-trial-top-header').length) {
      if (currentTenant === DEFAULT_TENANT) {
        setCurrentTenant('trial');
      }
    }
  };

  useDebounce(handleMainTenantJSRenameInTrialMode, 200, [currentTenant]);

  useEffect(() => {
    setCurrentTenant(getTenant());
    if (isJSON(localStorage.getItem('current_tenant'))) {
      setIsTenantAdmin(
        !!JSON.parse(localStorage.getItem('current_tenant'))?.is_admin
      );
    }
  }, []);

  return (
    <div className="w-layout-vflex-account-ui account-user-details-content-block">
      <div
        onClick={() => handleImgUploadClick()}
        className={`w-layout-hflex-account-ui mentor-image-uploader ${
          !isProfilePicSet ? 'empty' : ''
        }`}
      >
        <input
          ref={uploadInputElement}
          onChange={!!isProfilePicSet ? () => {} : handleImgUploadChange}
          type="file"
          className="input-mentor-image-upload"
          accept="image/*"
        />
        <div
          className={`w-layout-hflex-account-ui upload-text-box ${
            !!isProfilePicSet ? 'hidden' : ''
          }`}
        >
          <div className="text-block-52">{t('+ Upload')}</div>
        </div>
        <div
          className={`w-layout-hflex-account-ui upload-img-box ${
            !!isProfilePicSet ? '' : 'hidden'
          }`}
          style={{
            backgroundImage: `url(${profilePic})`,
          }}
        >
          <div className="w-layout-hflex-account-ui upload-action-btn-container">
            <img
              onClick={() => handleImgPreviewClick()}
              src={eyeImg}
              loading="lazy"
              alt=""
              className="upload-action-btn-icon view"
            />
            <img
              onClick={() => handleImgRemove()}
              src={trashImg}
              loading="lazy"
              alt=""
              className="upload-action-btn-icon remove"
            />
          </div>
        </div>
      </div>
      <div className="w-layout-vflex-account-ui account-user-specific-details-block">
        <h5 className="account-userfullname">{userMetaData?.name || ''}</h5>
        <div className="w-layout-hflex-account-ui account-info-pill-block">
          <div className="w-layout-hflex-account-ui info-pill-block">
            <FiUser
              className={'info-pill-icon'}
              size={13}
              style={{
                height: '13px',
                width: '13px',
              }}
              color={'var(--accent, #4a78b8)'}
            />
            <div className="info-pill-label transform-uppercase">
              {isTenantAdmin ? t('Admin') : t('Student')}
            </div>
          </div>
          {currentTenant !== '' && (
            <div className="w-layout-hflex-account-ui info-pill-block filled">
              <img
                src={folderOpen}
                loading="lazy"
                alt=""
                className="info-pill-icon"
              />
              <div className="info-pill-label white transform-uppercase">
                {currentTenant}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
